export default {
    clientId: '1ccfdb48-515d-4512-8ce3-005bc89983a8',
    redirectUri: 'https://localhost:44370/IdentificationAAD',
    postLogoutRedirectUri: 'https://localhost:44370',
    endpoints: {
        api: "1ccfdb48-515d-4512-8ce3-005bc89983a8"
    },
    tenant: 'b851f440-5c3b-48d3-97b6-7afd41c0793d',
    cacheLocation: 'localStorage'
}